import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center py-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"7rem"} }, "Tìm kiếm", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalThemVatTu = _resolveComponent("ModalThemVatTu")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_Can = _resolveComponent("Can")!
  const _component_DetailTopicLottie = _resolveComponent("DetailTopicLottie")!
  const _component_LabelCustom = _resolveComponent("LabelCustom")!
  const _component_ResponsiveLayout = _resolveComponent("ResponsiveLayout")!
  const _component_BaseLink = _resolveComponent("BaseLink")!
  const _component_PageContentSection = _resolveComponent("PageContentSection")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_DanhSachVatTuTable = _resolveComponent("DanhSachVatTuTable")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_PageContentBase = _resolveComponent("PageContentBase")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.danhMucVatTu)
      ? (_openBlock(), _createBlock(_component_ModalThemVatTu, {
          key: 0,
          "is-modal-open": _ctx.isModalOpen,
          "selected-vat-tu-items": _ctx.allVatTuItems,
          "danh-muc-vat-tu-id": _ctx.danhMucVatTuId,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isModalOpen = false)),
          onAdded: _ctx.onAddedVatTuItems
        }, null, 8, ["is-modal-open", "selected-vat-tu-items", "danh-muc-vat-tu-id", "onAdded"]))
      : _createCommentVNode("", true),
    _createVNode(_component_PageContentBase, { plain: "" }, {
      default: _withCtx(() => [
        (_ctx.danhMucVatTu)
          ? (_openBlock(), _createBlock(_component_PageContentSection, {
              key: 0,
              alwaysExpanded: true
            }, {
              header: _withCtx(() => [
                _createTextVNode("Thông tin")
              ]),
              actions: _withCtx(() => [
                _createVNode(_component_Can, {
                  all: [_ctx.DANH_MUC_VAT_TU.SUA]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ButtonCustom, {
                      "button-type": _ctx.ButtonsType.EDIT,
                      classes: `rounded-none m-0`,
                      "color-type": _ctx.ButtonTypeColors.SUCCESS,
                      "tooltip-message": "Chỉnh sửa nhóm vật tư",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.push(`/quan-ly/danh-muc-vat-tu/cap-nhat/${_ctx.danhMucVatTuId}`)))
                    }, null, 8, ["button-type", "color-type"])
                  ]),
                  _: 1
                }, 8, ["all"])
              ]),
              illustration: _withCtx(() => [
                _createVNode(_component_DetailTopicLottie, { topic: "danh-muc-vat-tu" })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_ResponsiveLayout, null, {
                  "col-1": _withCtx(() => [
                    _createVNode(_component_LabelCustom, { "is-text-muted": "" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Tên nhóm:")
                      ]),
                      _: 1
                    })
                  ]),
                  "col-2": _withCtx(() => [
                    _createVNode(_component_LabelCustom, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.danhMucVatTu.ten_danh_muc), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  "col-3": _withCtx(() => [
                    _createVNode(_component_LabelCustom, { "is-text-muted": "" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Mã nhóm:")
                      ]),
                      _: 1
                    })
                  ]),
                  "col-4": _withCtx(() => [
                    _createVNode(_component_LabelCustom, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.danhMucVatTu.ma_danh_muc), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ResponsiveLayout, null, {
                  "col-1": _withCtx(() => [
                    _createVNode(_component_LabelCustom, { "is-text-muted": "" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Mô tả:")
                      ]),
                      _: 1
                    })
                  ]),
                  "col-2": _withCtx(() => [
                    _createVNode(_component_LabelCustom, { class: "w-80" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.danhMucVatTu.mo_ta || "-"), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  "col-3": _withCtx(() => [
                    _createVNode(_component_LabelCustom, { "is-text-muted": "" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Ngày tạo:")
                      ]),
                      _: 1
                    })
                  ]),
                  "col-4": _withCtx(() => [
                    _createVNode(_component_LabelCustom, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.moment(_ctx.danhMucVatTu.created_at).format("DD/MM/YYYY")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ResponsiveLayout, null, {
                  "col-1": _withCtx(() => [
                    _createVNode(_component_LabelCustom, { "is-text-muted": "" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Nhóm cha:")
                      ]),
                      _: 1
                    })
                  ]),
                  "col-2": _withCtx(() => [
                    (_ctx.danhMucVatTuCha)
                      ? (_openBlock(), _createBlock(_component_BaseLink, {
                          key: 0,
                          isOpenInNewTab: "",
                          to: {
              name: 'chi-tiet-danh-muc-vat-tu',
              params: { id: _ctx.danhMucVatTuCha.id },
            }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.danhMucVatTuCha.ten_danh_muc), 1)
                          ]),
                          _: 1
                        }, 8, ["to"]))
                      : (_openBlock(), _createBlock(_component_LabelCustom, {
                          key: 1,
                          isTextMuted: true
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Không có nhóm cha")
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                }),
                _createVNode(_component_ResponsiveLayout, null, {
                  "col-1": _withCtx(() => [
                    _createVNode(_component_LabelCustom, { "is-text-muted": "" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Tài khoản:")
                      ]),
                      _: 1
                    })
                  ]),
                  "col-2": _withCtx(() => [
                    _createVNode(_component_LabelCustom, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.danhMucVatTu?.tk_ketoan?.matk
                ? _ctx.danhMucVatTu?.tk_ketoan?.mact
                  ? `${_ctx.danhMucVatTu.tk_ketoan.matk} / ${_ctx.danhMucVatTu.tk_ketoan.mact} | ${_ctx.danhMucVatTu.tk_ketoan.tentk}`
                  : `${_ctx.danhMucVatTu.tk_ketoan.matk} | ${_ctx.danhMucVatTu.tk_ketoan.tentk}`
                : "-"), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.danhMucVatTu)
          ? (_openBlock(), _createBlock(_component_PageContentSection, {
              key: 1,
              alwaysExpanded: true
            }, {
              header: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.totalVatTuDisplay), 1)
              ]),
              actions: _withCtx(() => [
                _createVNode(_component_Can, {
                  all: [_ctx.DANH_MUC_VAT_TU.SUA]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ButtonCustom, {
                      "button-type": _ctx.ButtonsType.ADD,
                      classes: `rounded-none m-0`,
                      "color-type": _ctx.ButtonTypeColors.SUCCESS,
                      "tooltip-message": "Thêm vật tư vào nhóm",
                      onClick: _ctx.openModal
                    }, null, 8, ["button-type", "color-type", "onClick"])
                  ]),
                  _: 1
                }, 8, ["all"])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _hoisted_2,
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.searchTerm,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchTerm) = $event)),
                    style: {"width":"20rem"},
                    placeholder: "Tìm theo mã hoặc tên",
                    onInput: _ctx.search
                  }, null, 8, ["modelValue", "onInput"])
                ]),
                _createVNode(_component_DanhSachVatTuTable, {
                  items: _ctx.vatTuItems,
                  "cur-page": _ctx.currentPage,
                  "per-page": _ctx.perPage,
                  "show-edit-button": false
                }, null, 8, ["items", "cur-page", "per-page"]),
                (_ctx.vatTuItems.length > 0)
                  ? (_openBlock(), _createBlock(_component_Pagination, {
                      key: 0,
                      page: _ctx.currentPage,
                      "page-size": _ctx.perPage,
                      total: _ctx.totalItems,
                      onChangePage: _cache[3] || (_cache[3] = (value) => (_ctx.currentPage = value)),
                      onChangePageSize: _cache[4] || (_cache[4] = (value) => (_ctx.perPage = value))
                    }, null, 8, ["page", "page-size", "total"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}